document.addEventListener("DOMContentLoaded", function () {
  const mobileBtn = document.querySelector(".js-mobile-btn");
  const btnMobile = document.querySelector(".btn-mobile");
  const menuMobile = document.querySelector(".menu-mobile");

  const placeBtn = document.querySelector(".js-place-btn");
  const btnPlace = document.querySelector(".menu-place__button");
  const menuPlace = document.querySelector(".menu-place__nav");

  mobileBtn.addEventListener("click", function () {
    btnMobile.classList.toggle("click");
    menuMobile.classList.toggle("active");
  });

  if (placeBtn) {
    placeBtn.addEventListener("click", function () {
      btnPlace.classList.toggle("click");
      menuPlace.classList.toggle("active");
    });
  }
});
